export default __webpack_public_path__ + "static/ultrasonic-reflectoscope-fb06cf6ae7450e5e5ec18a06843f9fd5.jpg";